import { render, staticRenderFns } from "./SpecialtiesCombo.vue?vue&type=template&id=4851a095&scoped=true"
import script from "./SpecialtiesCombo.vue?vue&type=script&lang=js"
export * from "./SpecialtiesCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851a095",
  null
  
)

export default component.exports